import axios from 'axios';
import {
  APP_SETTING_LOAD_USER_ROLES_BEGIN,
  APP_SETTING_LOAD_USER_ROLES_SUCCESS,
  APP_SETTING_LOAD_USER_ROLES_FAILURE,
  APP_SETTING_LOAD_USER_ROLES_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadUserRoles(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_LOAD_USER_ROLES_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/role/`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_LOAD_USER_ROLES_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_LOAD_USER_ROLES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadUserRolesError() {
  return {
    type: APP_SETTING_LOAD_USER_ROLES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_LOAD_USER_ROLES_BEGIN:
      return {
        ...state,
        loadUserRolesPending: true,
        loadUserRolesError: null,
      };

    case APP_SETTING_LOAD_USER_ROLES_SUCCESS:
      return {
        ...state,
        loadUserRolesPending: false,
        loadUserRolesError: null,
        userRoles: action.data.content || [],
      };

    case APP_SETTING_LOAD_USER_ROLES_FAILURE:
      return {
        ...state,
        loadUserRolesPending: false,
        loadUserRolesError: action.data.error,
      };

    case APP_SETTING_LOAD_USER_ROLES_DISMISS_ERROR:
      return {
        ...state,
        loadUserRolesError: null,
      };

    default:
      return state;
  }
}
